export const TRANSLATIONS_EN_10203059 = {
    signature_suites: "TWO BEDROOM SUITES",
};
